export default () => {
  // elements
  const els = {
    header: document.querySelector('[data-layout-header]'),
    headerNav: document.querySelector('[data-layout-header-nav]'),
    hamburger: document.querySelectorAll('[data-layout-header-hamburger]'),
    mobileClose: document.querySelector('[data-layout-header-mobile-close]'),
  };

  const classes = {
    mobNavOpen: 'layout-header__nav--open',
    stickyNav: 'layout-header--sticky',
    stickyShow: 'layout-header--sticky-show',
  };

  //functions
  const openMobNav = () => {
    els.headerNav.classList.add(classes.mobNavOpen);
    document.body.style.overflow = 'hidden';
  };

  const closeMobNav = () => {
    els.headerNav.classList.remove(classes.mobNavOpen);
    document.body.style.overflow = '';
  };

  const showStickyNav = () => {
    els.stickyHeader.classList.add(classes.stickyShow);
  };

  const hideStickyNav = () => {
    els.stickyHeader.classList.remove(classes.stickyShow);
  };

  if (els.headerNav) {
    els.stickyHeader = els.header.cloneNode(true);
    els.stickyHeader.classList.add(classes.stickyNav);

    document.body.appendChild(els.stickyHeader);
    els.hamburger = document.querySelectorAll('[data-layout-header-hamburger]');

    els.hamburger.forEach((el) => el.addEventListener('click', openMobNav));
    els.mobileClose.addEventListener('click', closeMobNav);

    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 150) {
        showStickyNav();
      } else {
        hideStickyNav();
      }
    });
  }
};
